import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { userService } from '@paragon/data-connections';

import { getLoggedInUser } from '../../../selectors/users';
import { LoginForm } from '../components/LoginForm';
import { LoginTypography } from '../components/LoginTypography';

interface Props {
  readonly authorizationCode: string;
}

export function AuthorizeApiAccessPanel({ authorizationCode }: Props) {
  const currentUser = useSelector(getLoggedInUser)!;
  const [successfullyAuthorized, setSuccessfullyAuthorized] = useState(false);

  return (
    <LoginForm
      disabled={successfullyAuthorized}
      submitText="Authorize"
      onSubmit={async () => {
        await userService.api.authorizeApiAccess(currentUser.email, authorizationCode);
        setSuccessfullyAuthorized(true);
      }}
    >
      <LoginTypography>
        {successfullyAuthorized ? (
          <p>Success! You can now close this tab.</p>
        ) : (
          <>
            <p>Would you like to authorize this application to access Paragon on your behalf?</p>
            <p>Close this tab now to deny the request.</p>
          </>
        )}
      </LoginTypography>
    </LoginForm>
  );
}
